import React, {Component} from 'react';
import { connect } from 'react-redux';

import { t } from 'l10n';
import paths from 'paths';
import queryString from "query-string";

import '../../sass/scrollArea.scss';
import '../../sass/member/MemberMessage.scss';

import Button from 'pm-js/build/components/UIKit/Button';

import GenderIcon from 'components/GenderIcon';
import ProfileAvatar from 'components/ProfileAvatar';
import ModalBlacklist from '../../components/modals/ModalBlacklist';
import MessageDialogAction from 'components/message/MessageDialogAction';
import { Link, Redirect } from 'components/ReactRouterDomLocalized';

class PmConversationHeader extends Component {

    constructor(props) {
        super(props);

        this.state = {
            modalBlacklist: false,
            contextMenu: false
        };

    }

    deleteHistory() {
        this.props.dispatch({type: "PM_ACTION_DELETE_HISTORY", conversation_uid: this.props.pmConversation.user.uid});
        if (this.props.onDeleteHistory) {
            this.props.onDeleteHistory();            
        }
    }

    revokePermission() {
        this.props.dispatch({type: "PM_ACTION_REVOKE_PERMISSION", conversation_uid: this.props.pmConversation.user.uid});
        if (this.props.onRevoke) {
            this.props.onRevoke();            
        }
    }

    openMenu() {
        this.setState({contextMenu: !this.state.contextMenu});
    }

    render() {
        const { 
            modalBlacklist
        } = this.state;

        const pmConversation = this.props.pmConversation;
        let recipient = pmConversation.user;

        let allowed = pmConversation.generalStatus == 'allowed';

        return (
            <div className="pm-conversation-header">
                
                    <div className="top">

                        
                        <div className="full-panel">
                        <div className="top-info-user">
                            <Link to={recipient.profile_url} className="user-info">
                                <ProfileAvatar user={recipient} />
                                <div className="name-user">
                                    <GenderIcon user={recipient} />
                                    <p>{recipient.nick}</p>
                                </div>
                            </Link>
                            
                            {allowed && 
                                <div className="links">
                                    <Button text="Menu" onClick={this.openMenu.bind(this)}/>
                                </div>}
                        </div>

                        {this.state.contextMenu && <div className="top-panel context-menu links">
                            <div className="links">
                                <Button text={t('Delete history')} onClick={this.deleteHistory.bind(this)}/>
                                <Button text={t('Revoke permission')} onClick={this.revokePermission.bind(this)}/>
                                </div>
                            </div>}

                    </div>
                    
                </div>
                <ModalBlacklist
                    show={modalBlacklist}
                    closeFn={() => this.setState({modalBlacklist: false})}
                    blacklistedByMe={recipient.blacklistedByMe}
                    user={recipient}
                />
            </div>
        )
    }
}

export default connect()(PmConversationHeader);


// WEBPACK FOOTER //
// ./src/components/pm/PmConversationHeader.js